import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class DashService {

  url=ConfigService.toApiUrl("v1/dash/");

  constructor(private http:HttpClient) { }

  
  getDash(){
    return this.http.get<any>(`${this.url}stats`,
     ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName),true));
  }

  getFinancialDash(){
    return this.http.get<any>(`${this.url}fianacial-stats`,
     ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName),true));
  }
}
